import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/**
 * Custom TranslateLoader that supports locale fallback.
 * For example, if 'en-US.json' doesn't exist, it will try 'en.json'.
 * If 'fr-FR.json' doesn't exist, it will try 'fr.json'.
 */
export class CustomTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private prefix: string = './assets/i18n/',
    private suffix: string = '.json'
  ) {}

  /**
   * Gets the translations from the server
   * First tries the full locale (e.g., 'en-US.json')
   * If that fails, tries the base language (e.g., 'en.json')
   */
  getTranslation(lang: string): Observable<any> {
    const fullPath = `${this.prefix}${lang}${this.suffix}`;
    
    return this.http.get(fullPath).pipe(
      catchError(() => {
        // If full locale fails, try base language
        const baseLang = lang.split('-')[0];
        if (baseLang !== lang) {
          const basePath = `${this.prefix}${baseLang}${this.suffix}`;
          return this.http.get(basePath).pipe(
            catchError(() => {
              console.warn(`Translation file not found for '${lang}' or '${baseLang}', returning empty translations`);
              return of({});
            })
          );
        }
        console.warn(`Translation file not found for '${lang}', returning empty translations`);
        return of({});
      })
    );
  }
}

/**
 * Factory function for creating CustomTranslateLoader
 */
export function customTranslateLoaderFactory(http: HttpClient): CustomTranslateLoader {
  return new CustomTranslateLoader(http, './assets/i18n/', '.json');
}
